import React, { memo } from 'react';
import { Card } from 'react-bootstrap';

const NoData = () => {
  return (
    <Card>
      <Card.Body>
        <Card.Text>No matching data for the logged in user.</Card.Text>
      </Card.Body>
    </Card>
  );
};

export default memo(NoData);
